import { Component, OnInit } from "@angular/core";
import { DataService_BusTrackerBusMaintenance } from "./shared/data.service";

@Component({
	selector: "app-bus-maintenance",
	templateUrl: "./bus-maintenance.component.html",
	styleUrls: ["./bus-maintenance.component.css"],
})
export class BusMaintenanceComponent implements OnInit {
	constructor(private busService: DataService_BusTrackerBusMaintenance) {}

	ngOnInit(): void {
		this.loadImportPref();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	ImportLoading: any = true;
	Imported: any = false;

	SelectedBus: any;
	SelectedRoute: any;

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////
	loadImportPref() {
		this.ImportLoading = true;

		var result = this.busService.ImportPreferenceSelect();
		result.subscribe(
			(response) => {
				this.Imported = response;

				this.ImportLoading = false;
			},
			(error) => {
				this.ImportLoading = true;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////

	onSelectedBusChanged(val) {
		this.SelectedBus = val;

		this.SelectedRoute = null;
	}

	onSelectedRouteChanged(val) {
		this.SelectedRoute = val;
	}

	/////////////////////////////////////////////////////////////////////
}
